const CONFIG = {
    // API_URL: 'http://localhost:8000',
    // BASE_URL: 'http://localhost:3000/relocation'
    API_URL: 'https://mouv-immo.com/relocation',
    BASE_URL: 'https://mouv-immo.com/relocation'
}

export default CONFIG;
